export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/stop-icon.svg?ad9bb391b8fa3c8ce16955edbb961d8f";